<template>
    <div class="report-result-button-unlock">
        <button @click="clickPay" class="report-rbul-button" v-bind:class="'report-rbul-button-'+buttonType">
            <!-- 加载状态 -->
            <span v-if="buttonLocked" class="report-rbul-button-span">
                <div class="lds-default report-rbul-button-loading"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                <span class="report-rbul-button-span-loading">解锁中</span>
            </span>
            <!-- 正常状态:付费解锁 -->
            <span v-else class="report-rbul-button-span">
                <i class="iconfont icon-key"></i>{{showLimit ? '限时半价' : ''}}{{productData.price ? (discount ? parseFloat(productData.price/100/2) : parseFloat(productData.price/100)) : ''}}元解锁{{showTwo ? '两项分析' : ''}}
            </span>
        </button>
    </div>
</template>

<script>
export default {
    name: 'NatureButton',
    props: {
        buttonType: {
            type: String,
            default() {
                return ''
            }
        },
        productData: {
            type: Object,
            default() {
                return {}
            }
        },
        showLimit: {
            type: Boolean,
            default() {
                return false;
            }
        },
        showTwo: {
            type: Boolean,
            default() {
                return false;
            }
        },
        discount: {
            type: Boolean,
            default() {
                return false;
            }
        },
        clickFunc: {
            type: Function,
            default() {
                return function(){}
            }
        }
    },
    data() {
        return {
            buttonLocked: false
        }
    },
    methods: {
        clickPay() {
            if(this.buttonLocked) { return; }
            this.buttonLocked = true;
            var me = this;
            if(this.clickFunc && typeof(this.clickFunc) == 'function') {
                this.clickFunc({
                    data: this.productData,
                    cb: function() {
                        me.buttonLocked = false;
                    }
                });
                setTimeout(() => {
                    me.buttonLocked = false;
                }, 5000);
            }
        }
    }
}
</script>